/**
 * Creates an apiUrl that supports multilingual.
 * Don't pass locale for non-multilingual sites.
 * For multilingual it should be: [baseUrl]/en_GB/resourceapi/[path]
 * By default it should be: [baseUrl]/resourceapi/[path]
 */ function createBloomreachApiUrl(baseUrl, locale) {
    if (locale !== undefined && !baseUrl.includes(locale.replace('-', '_'))) {
        return `${baseUrl}/${locale.replace('-', '_')}`;
    }
    return baseUrl;
}

export { createBloomreachApiUrl };
//# sourceMappingURL=create-api-url.js.map
